export const classes = {
  wrapper: 'size-10 place-center rounded-lg bg-grey-2 dark:bg-white/[0.06]',
  done: 'bg-green-3 text-white',
  failed:
    'bg-red-3 text-white transition-colors hover:bg-red-4 disabled:cursor-default disabled:hover:bg-red-3',
};
